import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import Autocomplete from 'react-autocomplete'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { useTranslation } from 'react-i18next'
import { endOfDay } from "date-fns"

import momenttz from '../../component/helpers/momenttz'
import { tableExportOptions } from '../../component/helpers/table'
import { getDevicesList } from '../../action/DeviceActions'
import ModalSelectNewDriver from '../../component/smart/modals/ModalSelectNewDriver'
import { searchIcon } from '../../component/helpers/iconHelpers'
import DateDropdown from '../../component/dump/menuComponents/DateDropdown'
import { getCompanyDrivers, getUnknownDriversTrip } from "../../action/CompaniesActions";

const UnknownDriverTrips = (props) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'driversPage.modalUnknownDriverTrips' });
	const { isUsingDriverFaceID, company, toggleLoader } = props;

	const [unknownDrivers, setUnknownDrivers] = useState([]);
	const [initialData, setInitialData] = useState([]);
	const [autoValue, setAutoValue] = useState('');
	const [location, setLocation] = useState(null);
	const [selectedRow, setSelectedRow] = useState(null);
	const [selectdriverShow, setSelectdriverShow] = useState(false);
	const [refreshModalUnknownDriver, setRefreshModalUnknownDriver] = useState(false);
	const [devices, setDevices] = useState([]);
	const [drivers, setDrivers] = useState([]);
	const [startDate, setStartDate] = useState(moment().format('YYYYMMDD'));
	const [endDate, setEndDate] = useState(moment().format('YYYYMMDD'));
	const [upd, setUpd] = useState(false);
	const prevProps = useRef(props).current;

	useEffect(() => {
		const { location } = props;

		let locationNew = null;
		if (location && location.state && location.state.type === 'redirectFromTripReplay') {
			locationNew = {
				type: location.state.type,
				event: location.state.event,
			}

			setLocation(locationNew)
			// ToDo: Refactoring/Check. Do we need this replace here?
			navigate('/managedrivers', {
				state: {},
				replace: true,
			})
		}

		if (company.company_id) {
			getDrivers();
		}
	}, [company.company_id])

	useEffect(() => {
		if (location && location.event && location.type === 'redirectFromTripReplay') {
			const obj = devices.find((elem) => elem.device_id === location.event.event_device_id)

			if (obj) {
				setAutoValue(obj.vehicle_name || obj.device_id);
			}
		}
	}, [])

	useEffect(() => {
		if (prevProps.location && prevProps.location.event && prevProps.location.type === 'redirectFromTripReplay') {
			const obj = prevProps.devices.find(({ device_id }) => device_id === prevProps.location.event.event_device_id);
			if (obj) {
				setAutoValue(obj.vehicle_name || obj.device_id);
				setStartDate(moment(prevProps.location.event.event_ts).format('YYYYMMDD'));
				setEndDate(moment(prevProps.location.event.event_ts).format('YYYYMMDD'));
				getUnknownDrivers();
			}
		} else if (
			prevProps.company.company_id
			&& prevProps.company.partner
			&& (
				(prevProps.company.company_id !== company.company_id)
				|| (prevProps.company.partner !== company.partner)
			)
		) {
			getUnknownDrivers();
		} else if ((prevProps.refreshModalUnknownDriver !== refreshModalUnknownDriver)) {
			getUnknownDrivers();
		}
	}, [company.company_id, company.partner, refreshModalUnknownDriver])

	const getUnknownDrivers = (argCompanyId = null, start_ts = false, end_ts = false) => {
		start_ts = start_ts || startDate;
		end_ts = end_ts || endDate;

		if (!start_ts
			|| !end_ts
			|| (moment(end_ts).diff(start_ts) < 0)
		) {
			toastr.error(t('selectEndDate/StartDate'));
			return
		}

		toggleLoader(true)
		const params = {
			companyId: argCompanyId || company.company_id,
			start_ts: moment(start_ts).format('YYYYMMDD000000'),
			end_ts: moment(end_ts).format('YYYYMMDD235959'),
			include_data: 'driver_photos',
		}
		getUnknownDriversTrip(params)
			.then(res => {
				const drivers = res.data.response
				let filter = drivers
				if (autoValue) {
					const value = autoValue.toLowerCase();
					filter = drivers.filter(item => (
						(item.device_id && item.device_id.toString().toLowerCase().includes(value))
						|| (item.vehicle_name && item.vehicle_name.toLowerCase().includes(value))
					))
				}
				setUnknownDrivers(filter);
				setInitialData([...drivers]);
				setUpd(!upd);
				toggleLoader(false);
			})
			.catch((error) => {
				setUnknownDrivers([]);
				setInitialData([]);
				toggleLoader(false)
				console.log('!getEventDriver error: ', error.response, error)

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const getDrivers = () => {
		toggleLoader(true);
		const requestArray = [];
		const params = {
			companyId: company.company_id,
		};
		if (isUsingDriverFaceID) {
			params.include_data = 'photos,legal_consent'
		}
		requestArray.push(getCompanyDrivers(params));
		requestArray.push(getDevicesList(company.company_id));

		Promise.all(requestArray)
			.then(res => {
				toggleLoader(false);

				const drivers = _.get(res[0], 'data.response.drivers', [])
				const devices = _.get(res[1], 'data.response.devices', [])

				setDevices(devices)
				setDrivers(drivers)
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('getDriversError: ', error);
			})
	}

	const redirectToTripReplay = (unknownDriver) => {
		const { setDashboardRedirect } = props;
		setDashboardRedirect({
			type: 'redirectFromUnknownDrivers',
			...unknownDriver,
		})
		navigate('/');
	}

	const closeSelectDriver = () => {
		setSelectdriverShow(false)
		setRefreshModalUnknownDriver(!refreshModalUnknownDriver)
	}

	const onDateChanged = (start_date, end_date) => {
		const start_ts = moment(start_date).format('YYYYMMDD');
		const end_ts = moment(end_date).format('YYYYMMDD');
		setStartDate(start_ts);
		setEndDate(end_ts);
		getUnknownDrivers(null, start_ts, end_ts);
	};

	const displayItemName = (item) => {
		return item.vehicle_name || item.device_id
	}

	const getItemValue = (item) => {
		return item.vehicle_name || item.device_id;
	}

	const matchStateToTerm = (item, value) => {
		if (item.vehicle_name) {
			return item.vehicle_name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
		}

		return item.device_id.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
	}

	const vehicleNameFormatter = (cell, row) => row.vehicle_name || row.device_id;

	const vehicleNameSortFunc = (a, b, order) => {
		const first = (a.vehicle_name || a.device_id.toString())
		const second = (b.vehicle_name || b.device_id.toString())
		return order === 'asc' ? second.localeCompare(first) : first.localeCompare(second)
	}

	const timestampFormatter = (cell) => {
		if (cell) {
			return momenttz(`${cell}+00`).format('M/DD/YYYY hh:mm:ss A');
		}
	}

	const durationFormatter = (cell) => {
		// const totalMinutes = cell || 0;
		// const hours = Math.floor(totalMinutes / 60);
		// const minutes = totalMinutes % 60;
		// return (hours ? (hours + ' hrs') + ' ' : '') + (minutes ? (minutes + ' mins') : '');

		const totalSeconds = cell || 0
		return moment.duration(totalSeconds, 'seconds').format('h [hrs] m [min] s [sec]', { trim: 'both' })
	}

	const searchVehicle = (value) => {
		const val = value.toLowerCase();
		let filter = initialData;
		if (val) {
			filter = initialData.filter(item => (
				(item.device_id && item.device_id.toString().toLowerCase().includes(val))
				|| (item.vehicle_name && item.vehicle_name.toLowerCase().includes(val))
			))
		}

		setUnknownDrivers(filter);
	}

	const handleViewTripClick = (e, row) => {
		e.preventDefault()
		redirectToTripReplay(row)
	}

	const handleIdDriverClick = (e, row) => {
		e.preventDefault();
		setSelectedRow(row);
		setSelectdriverShow(true);
	}

	const actionsFormatter = (cell, row) => {
		return (
			<span>
				<a href="/" onClick={e => handleViewTripClick(e, row)} style={{ marginRight: '15px' }}>
					{t('linkViewTrip')}
				</a>
				<a href="/" onClick={e => handleIdDriverClick(e, row)}>
					{isUsingDriverFaceID ? t('linkDriverSnapshots') : t('linkIDDriver')}
				</a>
			</span>
		)
	}

	const formatCSVFileName = () => {
		const timeframe = moment(startDate).format('M-D-YY') + (startDate === endDate ? '' : '--' + moment(endDate).format('M-D-YY'))
		return `${t('csvFileName')}_${timeframe}.csv`
	}

	return (
		<>
			<div className='page-subheader'>
				<div className='subheader-section search-flex'>
					<div className='search-bar-wrapper'>
						<Autocomplete
							autoHighlight
							value={autoValue}
							inputProps={{ id: 'states-autocomplete' }}
							wrapperProps={{ className: 'search-autocomplete unknownDriver' }}
							wrapperStyle={{ position: 'relative', zIndex: 1 }}
							getItemValue={getItemValue}
							shouldItemRender={matchStateToTerm}
							menuStyle={{
								borderRadius: '3px',
								boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
								background: 'rgba(255, 255, 255, 0.9)',
								padding: '2px 0',
								fontSize: '90%',
								position: 'absolute',
								overflow: 'auto',
								maxHeight: '200px',
								left: '2.5%',
								top: 'auto'
							}}
							onChange={(e, value) => {
								setAutoValue(value);
								searchVehicle(value);
							}}
							onSelect={(value, item) => {
								setAutoValue(value);
								searchVehicle(value);
							}}
							renderMenu={function (items, value, style) {
								return <div className="items-list" style={{ ...style, ...this.menuStyle }} children={items} />
							}
							}
							renderItem={(item, isHighlighted) => (
								<div
									className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
									key={item.device_id}
								>
									{displayItemName(item)}
								</div>
							)}
							renderInput={(props) => (
								<input {...props} placeholder={t('placeholderSearchVehicle')} className="vehicle-search" />
							)}
							items={devices}
						/>
						{searchIcon}
					</div>
					<DateDropdown
						start_date={startDate}
						end_date={endDate}
						onSelectDate={onDateChanged}
						limitDates={['THIS_WEEK', 'THIS_MONTH', 'LAST_MONTH']}
						maxDate={endOfDay(new Date())}
					/>
				</div>
			</div>

			<main className="main-content-block unknown-drivers-trips">
				<BootstrapTable
					data={unknownDrivers}
					{...tableExportOptions}
					csvFileName={formatCSVFileName()}
				>
					<TableHeaderColumn
						dataField="id"
						isKey
						hidden
					/>
					<TableHeaderColumn
						width="18%"
						dataField="device_id"
						dataFormat={vehicleNameFormatter}
						dataSort
						sortFunc={vehicleNameSortFunc}
					>
						{t('headerAssetName')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="18%"
						dataField="start_ts"
						dataFormat={timestampFormatter}
						dataSort
					>
						{t('headerTripStart')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="18%"
						dataField="end_ts"
						dataFormat={timestampFormatter}
						dataSort
					>
						{t('headerTripEnd')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="18%"
						dataField="duration"
						dataFormat={durationFormatter}
						dataSort
					>
						{t('headerDuration')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="30%"
						dataFormat={actionsFormatter}
						tdStyle={{ whiteSpace: 'normal' }}
					>
						{t('headerActions')}
					</TableHeaderColumn>
				</BootstrapTable>
			</main>

			{selectdriverShow &&
				<ModalSelectNewDriver
					drivers={drivers}
					selectedRow={selectedRow}
					isUsingDriverFaceID={isUsingDriverFaceID}
					onHide={closeSelectDriver}
				/>
			}
		</>
	);
}

const mapStateToProps = ({ user, company }) => ({
	user: user.user,
	company: company.company
});

const mapDispatchToProps = dispatch => ({
	setDashboardRedirect: (state) => {
		dispatch({ type: 'SET_DASHBOARD_REDIRECT', payload: state })
	},
	toggleLoader: (show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(UnknownDriverTrips);
